import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const dateOfBirth: AnswerPathTreeNode = { path: 'dateOfBirth', nodeId: NodeIds.insuredDateOfBirth };
